import request from '@/utils/request3'
import store from '@/store'

const serviceName = store.state.serviceName.wflow

// 流程定义分页查询
export function listFlow(data) {
  return request({ url: serviceName + `/wflow/flow/list`, method: 'post', data })
}

// 查询已发布流程(供发起申请选择)
export function publishedFlows() {
  return request({ url: serviceName + `/wflow/flow/published`, method: 'get' })
}

// 查询指定分类下已使用过的二级分类(供设计器录入建议)
export function listSubCategories(category) {
  return request({ url: serviceName + `/wflow/flow/subCategories`, method: 'get', params: { category } })
}

// 查询已使用过的一级分类(供流程管理列表页分类下拉)
export function listCategories() {
  return request({ url: serviceName + `/wflow/flow/categories`, method: 'get' })
}

// 按id查询流程定义
export function getFlow(id) {
  return request({ url: serviceName + `/wflow/flow/get`, method: 'get', params: { id } })
}

// 新增或修改流程定义(草稿)
export function saveFlow(data) {
  return request({ url: serviceName + `/wflow/flow/save`, method: 'post', data })
}

// 发布流程
export function publishFlow(id) {
  return request({ url: serviceName + `/wflow/flow/publish`, method: 'get', params: { id } })
}

// 停用流程
export function disableFlow(id) {
  return request({ url: serviceName + `/wflow/flow/disable`, method: 'get', params: { id } })
}

// 复制流程
export function copyFlow(id) {
  return request({ url: serviceName + `/wflow/flow/copy`, method: 'get', params: { id } })
}

// 删除流程
export function deleteFlow(id) {
  return request({ url: serviceName + `/wflow/flow/delete`, method: 'get', params: { id } })
}
